export var TIMELINE_START = 'timelinestart';
export var TIMELINE_END = 'timelineend';
export var VALUE_CHANGE = 'valueChange';
export var TIMEBAR_CONFIG_CHANGE = 'timebarConfigChanged';
export var PLAY_PAUSE_BTN = 'playPauseBtn';
export var NEXT_STEP_BTN = 'nextStepBtn';
export var PRE_STEP_BTN = 'preStepBtn';